<template>
  <div class="accountActivation">
    <div class="accountActivation-box" v-if="!isActiveAccount">
      <form method="post" id="create-person-form" @submit.prevent="activateUser">
        <h3>Активация аккаунта</h3>
        <input class="accountActivation-input" type="password" v-model="form.password" required placeholder="Введите пароль">
        <br>
        <input class="accountActivation-input" type="password" v-model="form.re_password" required placeholder="Повторите пароль">
        <br>

        <input class="accountActivation-input" type="email" v-if="this.USER.email === 'test@mail.ru'" v-model="form.email" required placeholder="Введите почту">
        <br>
        <button class="accountActivation-button" type="submit">Активировать учетную запись</button>
      </form>
    </div>
    <div v-else>
      <h1>Поздравляем, Ваша учетная запись успешно активирована!</h1>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "ActivateUser",
  data() {
    return {
      form: {
        password: '',
        re_password: '',
        email: ''
      }
    }
  },
  methods: {
    activateUser() {
      if (this.form.password !== this.form.re_password){
        this.$store.dispatch("addNotification", {
          type: "error",
          message: "Пароли не совпадают",
        });
        this.form.password = '';
        this.form.re_password = '';
      } else {
        let formData = this.form;
        this.$store.dispatch('activateUser', formData);
      }

    }
  },
  computed: {
    ...mapGetters([
      'isActiveAccount',
        'USER'
    ])
  },
}
</script>

<style scoped>
.accountActivation {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
}

.accountActivation-box {
  border-radius: 10px;
  /* box-shadow: 10px 10px 10px #2a65a3, 10px 10px 10px #2f77c1; */
  box-shadow: 0 0 5px rgba(0, 50, 0, 0.5);
  /* width: 500px;
  height: 500px; */
  padding: 3rem;
  background: #E5E5E5;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.accountActivation-input {
  border: 1px solid #E3E3E3;
  padding: 1rem;
  border-radius: 15px;
  margin: 1rem;
}

.accountActivation-input:focus {
  outline: none;
}

.accountActivation-button {
  padding: 1rem 2rem;
  border: none;
  outline: none;
  border-radius: 10px;
  margin-left: 1rem;
  cursor: pointer;
  font-size: 1.1rem;
  background: #7AD38D;
  color: white;
}


</style>